import { Component, OnDestroy, OnInit } from '@angular/core';
import { Sensor, excludedSensorTypes, IValue, ApplianceTypes } from 'src/app/models/sensor';
import { Router, ActivatedRoute } from '@angular/router';
import { Zone } from 'src/app/models/zone';
import { Appliance } from 'src/app/models/appliance';
import { DataService } from 'src/app/services/data.service';
import { SocketIoService } from 'src/app/services/socket-io.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ZoneService } from '../../../services/zone.service';
import { ApiService } from "src/app/services/api.service";
import { AddDialogComponent } from'../../clients/add-dialog/add-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';

export interface Category {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-sensors',
  templateUrl: './sensors.component.html',
  styleUrls: ['./sensors.component.less']
})
export class SensorsComponent implements OnInit, OnDestroy {
  zone: Zone
  currentCompany: any = null;
  currentCompanyId: string | null = null;
  categories: Category[] = [];
  sensors: Sensor[] = [];
  zones: Zone[] | null = null;

  subscription: Subscription;
  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private socketService: SocketIoService,
    private zoneService: ZoneService,
    private _api: ApiService,
    public dialog: MatDialog,
    public authService: AuthService,) {
 
      this.dataService.sharedCompanyId$.subscribe(companyId => {
        this.currentCompanyId = companyId;
        if (!companyId && localStorage.getItem('currentCompany')) {
          let company = JSON.parse(localStorage.getItem('currentCompany'));

          this.currentCompany = company ? company.name : null
          this.currentCompanyId = company ? company._id : null
        }
      })

      // this.subscription = this.dataService.sharedSensors$.pipe(take(1)).subscribe(sensors => {
      //   if (sensors === undefined) {
      //     return;
      //   }
      //   if(!sensors){
      //     // this.getZones();
      //   }else{
      //     // this.zone = zone;
      //     this.sensors = sensors.filter(x => !ApplianceTypes.includes(x.kind));
      //     this.sensors.forEach(x => x.kind = x.kind == 's1' ? 'sky' : x.kind);
      //     this.sensors.forEach(x => {
      //       x.lastValues = x.lastValues?.filter(v =>
      //         !excludedSensorTypes.includes(v.value?.type)
      //       )
      //     })
      //     // this.appliances = Appliance.reduceAppliances(this.zone.sensors, this.zone.online);
      //     // this.zone.appliances = this.appliances;
      //   }

        
        
      // })

      // this.dataService.sharedCompany$.subscribe(company => {
      //   this.currentCompany = company;
      // })

      // this.dataService.sharedCompanyId$.subscribe(companyId => {
      //   this.currentCompanyId = companyId;
      // })

      

      this.categories = [
        { value: 'sky', viewValue: '#Air' },
        { value: 'root', viewValue: '#Root' },
        { value: 'water', viewValue: '#Irrigation' },
        { value: '', viewValue: '#General' }];
  }

  ngOnInit(): void {
    this.getSensors()
  }

  getSensors(){
    let zones = []
    let list = JSON.parse(localStorage.getItem('zoneList'));
    zones = list.map(zone => {
      return zone._id
    })
    this._api.post<any>(`/sensor/getSensors`, {zones: zones}).subscribe(resp => {
        this.sensors = resp.sensors;
        this.sensors = resp.sensors.filter(x => !ApplianceTypes.includes(x.kind));
          this.sensors.forEach(x => x.kind = x.kind == 's1' ? 'sky' : x.kind);
          this.sensors.forEach(x => x.kind = x.kind == 's2' ? 'sky' : x.kind);
          this.sensors.forEach(x => x.kind = x.kind == 'cwt-air' ? 'sky' : x.kind);
          this.sensors.forEach(x => x.kind = x.kind == 'cwt-sky' ? 'sky' : x.kind);          
          this.sensors.forEach(x => {
            x.lastValues = x.lastValues?.filter(v =>
              !excludedSensorTypes.includes(v.value?.type)
            )
          })       
    }, err => {
        alert(err.message);
    });
  }

  addNew(type: string){
    let title = type[0].toUpperCase() + type.slice(1)
    let data: any = {
        type: type,
        company: this.currentCompanyId,
        title: title,
        name: '',
        function: (item) => this.add(type, item)
      }
    
    if(type === 'sensor' || type === 'cycle'){
        data = {...data, zone: this.zones}
    }
    
    const dialogRef = this.dialog.open(AddDialogComponent, {
        disableClose: true,
        data: data
        
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result === undefined) return;
        setTimeout(() => result.name);
        // this.create['company'] = {}
        // this.fetchData();
        this.getSensors()
      });
}

add(type: string, data: any) {
  return this._api.post<any>(`/${type}`, data);
}

//   getZones(): void {
//     let companyId = this.currentCompanyId
//     this.zoneService.companyZones(companyId).subscribe((response: Zone[]) => {

//         let zones = response;
//         if(zones.length === 0){
//         }
//         let listOfZones = zones.map(x => {
//             return { _id: x._id, name: x.name }
//         })

//         localStorage.setItem('zoneList', JSON.stringify(listOfZones));
//         if(zones.length){
//             this.currentCompany = zones[0]['company']
//             let company = {_id: zones[0]['company']._id, name: zones[0]['company'].name}
//             localStorage.setItem('currentCompany', JSON.stringify(company));
//             this.dataService.updateCompany(zones[0]['company'].name)
//             this.dataService.updateCompanyId(zones[0]['company']._id)
//         }

//         let sensors: any  = []
//         zones.forEach(zone => {
//             zone.reducedSensors = Sensor.breakdownSensors(zone.sensors, zone.alerts);
//             zone.alertSensors = Sensor.reduceSensorAlerts(zone.sensors, zone.alerts);
//             zone.alertAppliances = Sensor.reduceApplianceAlerts(zone.sensors, zone.alerts, ['status']);

//             zone.sensors.forEach(sensor => {
//                 sensor.zone = zone._id
//                 sensors.push(sensor)
//             });

            
//         })

//         this.dataService.updateSensors(sensors)
//         this.dataService.updateZones(zones);

//     }, (err) => {
//         switch (err.status) {
//             case 401:
//                 //   this._logger.info('Incorrect');
//                 break;
//         }
//     }, () => {
//         //   this._logger.info('Completed')
//     });
// }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }

  updateCurrentZone(zone: Zone) {
    this.dataService.updateZone(zone);
  }

  updateSensors() {
    this.getSensors()
  }

}
